import React from 'react';
import { openConsentManager } from '@segment/consent-manager';
import { Button, Flex, Box } from '@hausgold/designsystem';
import Link from './Link';
import { EVENT_OBJECT, EVENT_VERB, eventBuilder } from '../utils/tracking';

/*
 *  FooterStraightLine is used with a straight line – only for landingpages.
 */
const FooterStraightLines = ({ phoneNumber = '040 - 22 61 61 40' }) => (
  <footer className="text-muted bg-dark text-center text-md-left pb-6 pt-3 mt-6 mt-md-7">
    <div className="container">
      <div className="row d-flex my-6 justify-content-center">
        <div className="col-12">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={150}
            height={21}
            className="logo"
            viewBox="0 0 134 18"
          >
            <path
              fill="#fff"
              d="M133.45 5.5a9.8 9.8 0 01.06 6.38 7.95 7.95 0 01-4.29 4.81 8.8 8.8 0 01-3.76.75h-6.6V.01h6.6c1.4 0 2.64.25 3.71.75a7.92 7.92 0 014.28 4.75zm-4.27 4.9a5.94 5.94 0 00-.01-3.37 3.9 3.9 0 00-2.03-2.49 3.74 3.74 0 00-1.75-.39h-2v9.16h2a3.77 3.77 0 003.04-1.44c.35-.44.6-.94.76-1.47h-.01zM110.4.01h-4.53v17.43h10.81V13.3h-6.28zM103.86 5.04c.5 1.13.75 2.44.75 3.94a9.8 9.8 0 01-.65 3.64 8.3 8.3 0 01-1.83 2.83c-.8.8-1.76 1.43-2.81 1.84a10.2 10.2 0 01-6.9.11 7.92 7.92 0 01-4.79-4.47 9.8 9.8 0 01-.74-3.95c0-1.5.26-2.82.77-3.94A8.19 8.19 0 0192.52.57a9.9 9.9 0 016.52 0 8.22 8.22 0 014.82 4.47zm-4.14 5.98c.27-.65.4-1.34.38-2.04.01-.7-.11-1.39-.37-2.04a4.37 4.37 0 00-.98-1.45c-.39-.38-.85-.68-1.37-.87a4.48 4.48 0 00-1.56-.28c-.56 0-1.11.09-1.64.27-.52.18-1 .47-1.4.86-.43.4-.77.9-1 1.45-.25.65-.38 1.36-.37 2.06-.01.7.11 1.39.37 2.04a4.07 4.07 0 002.36 2.33 4.48 4.48 0 003.21 0 4.08 4.08 0 002.37-2.33zM76.82 7.8v3.9h3.76a3.7 3.7 0 01-1.55 1.73c-.6.32-1.36.47-2.27.47-.63.01-1.25-.11-1.83-.36-.53-.22-1-.57-1.38-1a4.64 4.64 0 01-.88-1.54 6.07 6.07 0 01-.32-2.02c0-.65.1-1.3.3-1.93.17-.57.46-1.11.84-1.58a4.04 4.04 0 013.27-1.5c.85 0 1.57.14 2.15.44.58.3 1.07.8 1.47 1.52h4.35s-.58-1.83-1.15-2.65A7.26 7.26 0 0079.36.36a9.65 9.65 0 00-5.8.22 8.24 8.24 0 00-4.88 4.5 9.41 9.41 0 00-.76 3.93c0 1.49.25 2.8.76 3.91a8.26 8.26 0 004.88 4.47 9.73 9.73 0 005.62.28 8.13 8.13 0 002.21-.9 7.12 7.12 0 003.14-3.91c.27-.82.44-1.66.5-2.52.04-.85.03-1.7-.04-2.53h-8.17zm-12.86.45c-.66-.4-1.4-.7-2.15-.84-.86-.18-1.72-.3-2.58-.38a7.18 7.18 0 01-1.92-.4c-.45-.18-.68-.56-.68-1.14-.01-.28.06-.56.22-.8.14-.2.33-.35.55-.45.24-.11.5-.19.75-.22.26-.04.51-.06.77-.06.56-.02 1.1.12 1.6.39.46.26.7.68.71 1.27h4.21A4.93 4.93 0 0063.4 1.4 6.5 6.5 0 0061.28.35a9.1 9.1 0 00-4.96 0c-.77.22-1.49.57-2.13 1.04a5.15 5.15 0 00-2.02 4.21c0 .9.18 1.67.54 2.28.35.61.83 1.13 1.42 1.51.62.4 1.3.7 2.01.86.76.2 1.53.31 2.31.36.31.02.65.04 1.02.08.35.03.7.1 1.03.23.3.11.57.3.8.53.2.23.31.55.31.96 0 .25-.07.5-.23.7-.17.2-.37.37-.6.5a4.18 4.18 0 01-3.68-.01 1.9 1.9 0 01-.61-.56c-.16-.23-.24-.5-.23-.78h-4.32a4.98 4.98 0 002.15 4.3c.7.48 1.46.83 2.28 1.03a10.53 10.53 0 005.26 0 7.3 7.3 0 002.28-1.02 5.32 5.32 0 001.6-1.72c.42-.73.63-1.57.61-2.4 0-1.07-.18-1.93-.55-2.6a4.37 4.37 0 00-1.51-1.6h-.1zM45.4 11.56a1.84 1.84 0 01-.8 1.57c-.23.17-.5.3-.8.37a3.39 3.39 0 01-1.84 0c-.29-.07-.56-.2-.8-.37a1.84 1.84 0 01-.8-1.56V0h-4.4v11.65a5.43 5.43 0 002.14 4.45c.68.5 1.43.89 2.24 1.13 1.7.51 3.53.51 5.23 0 .8-.24 1.56-.62 2.23-1.13a5.4 5.4 0 002.12-4.44V0H45.4v11.55zM28.7 13.62a27.45 27.45 0 01-4.73 3.23h10.78s-.92-3.2-2.3-6.85c-1.2 1.31-1.88 2.14-3.75 3.62z"
            />
            <path
              d="M15.98 17.4S20.53.01 25 .01c1.73 0 3.63 3.09 5.24 6.67-3.2 3.93-9 8.42-12.7 10.72h-1.56z"
              fill="#f46364"
            />
            <path
              fill="#fff"
              d="M9.93 6.28h-5.4V.01H0v17.3h4.53v-6.89h5.4v7.02h4.53V.01H9.93z"
            />
          </svg>
        </div>
      </div>
      <div className="row pb-md-7">
        <div className="col-12 col-md-6">
          <strong>Kostenlose Telefonberatung</strong>
          <h1 className="display-4 mt-2 mb-6 mb-md-0">
            <Link
              className="text-white"
              to={`tel:${phoneNumber}`}
              eventLabel={phoneNumber}
              eventName={eventBuilder(
                EVENT_OBJECT.footerLink,
                EVENT_VERB.interacted
              )}
            >
              {phoneNumber}
            </Link>
          </h1>
        </div>
      </div>
      <div className="d-block mb-6">
        <Button size="sm" variant="unstyled" onClick={openConsentManager}>
          Cookie Einstellungen
        </Button>
      </div>
      <Flex
        as="small"
        id="press-release-dates"
        color="gray.400"
        gap={1}
        textAlign="start"
      >
        <Box fontSize="xs">1</Box>
        <Box>
          FAZ Online, „Viele Kunden könnten zurückkommen“, 17.02.2022, Stand:
          19.10.2023 <br />
          FOCUS online, “Experte erklärt - Wohnimmobilien und Corona: Warum
          Immobilienbesitzer aufatmen können”, 25.05.2023, Stand: 19.10.2023
          <br />
          WELT Online, “Die Luxus-Wette ist verloren – jetzt beginnt das Zittern
          der Spekulanten”, 05.09.2022, Stand: 19.10.2023 <br />
          ZEIT ONLINE, “Unsanierte Immobilien: Das Haus besser saniert
          verkaufen”, 29.06.23, Stand: 19.10.2023
        </Box>
      </Flex>
      <hr />
      <small>
        <div>
          ©<span id="copyright">Copyright</span>- HAUSGOLD | talocasa GmbH | An
          der Alster 45 | 20099 Hamburg
          <Link
            style={{ margin: '5px' }}
            className="text-white float-right"
            eventName={eventBuilder(
              EVENT_OBJECT.footerLink,
              EVENT_VERB.interacted
            )}
            to="https://www.hausgold.de/impressum/"
            eventLabel="Impressum"
            eventParams={{ element_type: 'FooterStraightLine' }}
          >
            Impressum
          </Link>
          <Link
            style={{ margin: '5px' }}
            className="text-white float-right"
            eventName={eventBuilder(
              EVENT_OBJECT.footerLink,
              EVENT_VERB.interacted
            )}
            to="https://www.hausgold.de/datenschutz/"
            eventLabel="Datenschutz"
            eventParams={{ element_type: 'FooterStraightLine' }}
          >
            Datenschutz
          </Link>
        </div>
      </small>
    </div>
  </footer>
);

export default FooterStraightLines;
